"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const styleContents = __importStar(require("../style"));
const utils_1 = require("../../internal/utils");
const BaseStyle_1 = require("../style/BaseStyle");
const animate_1 = require("../../internal/animate");
const symbolManager_1 = require("../../internal/symbolManager");
const { setReadonly } = utils_1.obj;
const COLUMN_FADEIN_STATE_ID = symbolManager_1.getColumnFadeinStateId();
function isFadeinWhenCallbackInPromise(column, grid) {
    if (utils_1.isDef(column.fadeinWhenCallbackInPromise)) {
        return column.fadeinWhenCallbackInPromise;
    }
    return !!grid.configure("fadeinWhenCallbackInPromise");
}
function getFadinState(grid) {
    let state = grid[COLUMN_FADEIN_STATE_ID];
    if (!state) {
        state = { cells: {} };
        setReadonly(grid, COLUMN_FADEIN_STATE_ID, state);
    }
    return state;
}
function _generateFadinPointAction(grid, col, row, context, drawInternal, drawCellBase) {
    return (point) => {
        const state = getFadinState(grid);
        const stateKey = `${row}:${col}`;
        if (point === 1) {
            delete state.cells[stateKey];
        }
        else {
            state.cells[stateKey] = {
                opacity: point,
            };
        }
        drawCellBase();
        drawInternal();
        const cellState = state.cells[stateKey];
        if (cellState) {
            //透過するため背景を透過で上書き
            const ctx = context.getContext();
            ctx.globalAlpha = 1 - cellState.opacity;
            try {
                drawCellBase();
            }
            finally {
                ctx.globalAlpha = 1;
            }
        }
    };
}
const fadinMgr = {
    animate(grid, col, row, context, drawInternal, drawCellBase) {
        // fadein animation
        const state = getFadinState(grid);
        const activeFadeins = [
            _generateFadinPointAction(grid, col, row, context, drawInternal, drawCellBase),
        ];
        state.activeFadeins = activeFadeins;
        animate_1.animate(500, (point) => {
            activeFadeins.forEach((f) => f(point));
            if (point === 1) {
                delete state.activeFadeins;
            }
        });
    },
    margeAnimate(grid, col, row, context, drawInternal, drawCellBase) {
        const state = getFadinState(grid);
        if (state.activeFadeins) {
            state.activeFadeins.push(_generateFadinPointAction(grid, col, row, context, drawInternal, drawCellBase));
        }
        else {
            drawInternal();
        }
    },
};
class BaseColumn {
    constructor(option = {}) {
        this.onDrawCell = this.onDrawCell.bind(this); //スコープを固定させる
        //Promiseのcallbackでフェードイン表示する
        this._fadeinWhenCallbackInPromise =
            option.fadeinWhenCallbackInPromise || false;
    }
    get fadeinWhenCallbackInPromise() {
        return this._fadeinWhenCallbackInPromise;
    }
    get StyleClass() {
        return BaseStyle_1.BaseStyle;
    }
    onDrawCell(cellValue, info, context, grid) {
        var _a;
        const { style, getRecord, drawCellBase } = info;
        const helper = grid.getGridCanvasHelper();
        drawCellBase();
        const record = getRecord();
        let promise;
        if (utils_1.isPromise(record)) {
            promise = record.then(() => cellValue);
        }
        else if (utils_1.isPromise(cellValue)) {
            promise = cellValue;
        }
        //文字描画
        if (promise) {
            const start = Date.now();
            return promise.then((val) => {
                const currentContext = context.toCurrentContext();
                const drawRect = currentContext.getDrawRect();
                if (!drawRect) {
                    return;
                }
                const time = Date.now() - start;
                const drawInternal = () => {
                    const currentContext = context.toCurrentContext();
                    const drawRect = currentContext.getDrawRect();
                    if (!drawRect) {
                        return;
                    }
                    const record = getRecord();
                    if (utils_1.isPromise(record)) {
                        return;
                    }
                    const actStyle = styleContents.of(style, record, this.StyleClass);
                    this.drawInternal(this.convertInternal(val), currentContext, actStyle, helper, grid, info);
                    this.drawMessageInternal(info.getMessage(), currentContext, actStyle, helper, grid, info);
                };
                if (!isFadeinWhenCallbackInPromise(this, grid)) {
                    drawInternal(); //単純な描画
                }
                else {
                    const { col, row } = context;
                    if (time < 80) {
                        //80ms以内のPromiseCallbackは前アニメーションに統合
                        fadinMgr.margeAnimate(grid, col, row, context, drawInternal, drawCellBase);
                    }
                    else {
                        //アニメーション
                        fadinMgr.animate(grid, col, row, context, drawInternal, drawCellBase);
                    }
                }
            });
        }
        else {
            const actStyle = styleContents.of(style, record, this.StyleClass);
            this.drawInternal(this.convertInternal(cellValue), context, actStyle, helper, grid, info);
            this.drawMessageInternal(info.getMessage(), context, actStyle, helper, grid, info);
            //フェードインの場合透過するため背景を透過で上書き
            const { col, row } = context;
            const stateKey = `${col}:${row}`;
            const cellState = (_a = grid[COLUMN_FADEIN_STATE_ID]) === null || _a === void 0 ? void 0 : _a.cells[stateKey];
            if (cellState) {
                const ctx = context.getContext();
                ctx.globalAlpha = 1 - cellState.opacity;
                try {
                    drawCellBase();
                }
                finally {
                    ctx.globalAlpha = 1;
                }
            }
            return undefined;
        }
    }
    convertInternal(value) {
        return (utils_1.isDef(value) ? value : "");
    }
    drawMessageInternal(message, context, style, helper, grid, info) {
        info.messageHandler.drawCellMessage(message, context, style, helper, grid, info);
    }
    bindGridEvent(_grid, _cellId) {
        return [];
    }
    getCopyCellValue(value, _grid, _cell) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return value;
    }
}
exports.BaseColumn = BaseColumn;
